export default function () {
  return {
    profile: {},
    isLogged: false,
    isLoginPending: true,
    isMediclubMember: false,
    questionnaireStatuses: [],
  }
}
